<template>
  <div v-wechat-title="titleTop">
    <TopBar :pagetitle="title" :back-url="backurl" :back-level="1000" />
    <van-skeleton title :row="10" :loading="loadingPage">
      <div v-if="list.length <= 0" class="emptyFont">
        <div>暂未拥有会员卡<br>您可以扫描卡片二维码关联卡片</div>

      </div>
      <van-steps direction="vertical" :active="-1" class="cardlist">
        <van-step v-for="item in list" :key="item.card.memberCardId">
          <div>
            <div class="title">
              {{ item.name }}
              <van-tag v-if="!item.card.isPayFinish" type="primary" style="margin-left:1em" :color="GetColorMain()" @click="onSelectCard(item.card.hashCode,true)">尚未支付</van-tag>
              <!-- <van-tag v-if="!item.card.isPayFinish && !item.card.moneyId" type="primary" style="margin-left:1em" :color="GetColorMain()" @click="onSelectCard(item.card.hashCode,true)">立即支付</van-tag>
              <van-tag v-if="!item.card.isPayFinish && item.card.moneyId" type="primary" style="margin-left:1em" :color="GetColorMain()" @click="onViewPay(item.card)">查看支付结果</van-tag> -->

              <!-- {{ item.certificateDate?formatDate(item.certificateDate,"yyyy/MM/dd"):'-' }}<br>
              {{ item.cerificateName }} -->
            </div>
            <div class="body" @click="onSelectCard(item.card.hashCode,false)">
              <template v-if="item.card.isPayFinish">
                持有人: {{ item.card.viperName }}<br>
                卡号: {{ item.card.vipId }}<br>
                <template v-if="item.card.createTime || item.card.finishTime">
                  有效期: {{ item.card.createTime?formatDate(item.card.createTime,"yyyy/MM/dd"):'-' }} 至
                  {{ item.card.finishTime?formatDate(item.card.finishTime,"yyyy/MM/dd"):'-' }}
                  <van-tag v-if="!item.isInActivityTime" style="margin-left:0.5em" :color="GetColorMainBack()">未生效</van-tag><br>
                </template>
              </template>
            </div>
            <img :src="item.cardImgFront?item.cardImgFront:'/img/defaultcertificate.jpg'" @click="onSelectCard(item.card.hashCode,false)">
          </div>
        </van-step>
      </van-steps>
    </van-skeleton>
  </div>
</template>
<script>
import request from '@/utils/request'
import { Tag, Button, Step, Steps, Skeleton } from 'vant'
import TopBar from '@/components/TopBar'
import { ShowMoney, GetEnumText, formatDate } from '@/utils/base'
import { GetColorMainBack, GetColorMain, GetColorSecondary, GetSysTitle, GetColorMainLine } from '@/utils/base'
export default {
  components: {
    [Tag.name]: Tag,
    [Button.name]: Button,
    [Step.name]: Step,
    [Steps.name]: Steps,
    [Skeleton.name]: Skeleton,
    TopBar
  },
  data() {
    return {
      titleTop: '',
      title: '我的会员卡列表',
      backurl: '/my/index',
      list: [],
      loadingPage: true
    }
  },

  created() {
    this.titleTop = GetSysTitle()
    this.init()
  },
  methods: {
    ShowMoney,
    GetColorMainLine,
    GetColorMainBack,
    GetColorMain,
    GetColorSecondary,
    GetSysTitle,
    GetEnumText,
    formatDate,
    init() {
      this.loadingPage = true
      console.log('memberCardList init')
      request({
        url: '/MemberCard/GetMemberCardList',
        method: 'post'
      }).then(response => {
        this.loadingPage = false
        if (!response.success) {
          return
        }
        this.list = response.data
      })
    },
    onSelectCard(hashCode, onBuy) {
      this.$router.push('/m/' + hashCode)
      // if (onBuy) {
      //   this.$router.push('/m/' + hashCode + '?pay=1')
      // } else {
      //   this.$router.push('/m/' + hashCode)
      // }
    },
    onViewPay(card) {
      this.$router.push('/store/pay/0?id=' + card.moneyId)
    }
  }
}
</script>
<style scoped>
.pageBack{
  background-color: #fff;
}
.van-step__circle{
  background-color: #E32119;
  border: 1px solid #000;
}
.van-step__line{
  background-color: #000 !important;
  margin-left: 1px;
}
.cardlist .title
{
  color: #000 ;
  font-weight: 700;

}
.cardlist .body{
  color: #000;
  margin-top: 0.8em;
  font-size: 0.9em;
}
.cardlist img{
  width: 90%;
  margin-top: 0.8em;
  border-radius: 1em;
}

.emptyFont{
  text-align: center;
  color: #999;
  padding: 0 1em;
  margin-top: 30vh;
}
.addCer{
  font-size: 3em;
  font-weight: 700;
}

</style>
